class CollectionBannerSlider extends HTMLElement {
  connectedCallback() {
    // swiperJs.js is deferred at the end of <body>, so it runs after this script
    if (window.Swiper) {
      this.initSlider();
      return;
    }

    document.addEventListener('load:swiper', () => this.initSlider(), { once: true });
  }

  disconnectedCallback() {
    if (this.slider) {
      this.slider.destroy(true, true);
      this.slider = null;
    }
  }

  initSlider() {
    const viewportElement = this.querySelector('[data-slider-viewport]');

    if (!viewportElement || !window.Swiper || this.slider) return;

    const { loop } = this.dataset;
    const slidesCount = viewportElement.querySelectorAll('.swiper-slide').length;

    this.slider = new window.Swiper(viewportElement, {
      loop: loop === 'true' && slidesCount > 1,
      loopedSlides: slidesCount,
      speed: 500,
      grabCursor: true,
      watchOverflow: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      navigation: {
        prevEl: this.querySelector('[data-slider-prev]'),
        nextEl: this.querySelector('[data-slider-next]'),
        disabledClass: 'collection-banner-slider__arrow--disabled',
        lockClass: 'collection-banner-slider__arrow--hidden',
      },
    });
  }
}

if (!customElements.get('collection-banner-slider')) {
  customElements.define('collection-banner-slider', CollectionBannerSlider);
}
